(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["darvaza-live-search-homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeSearch(root) {
      if (!root || root.dataset.searchReady === "true") {
        return;
      }

      root.dataset.searchReady = "true";

      var input = root.querySelector(".dv-search-input");
      var form = root.querySelector(".dv-search-form");
      var panel = root.querySelector(".dv-search-panel");
      var topTemplate = root.querySelector(".dv-top-products-template");
      var predictiveSearchUrl =
        root.getAttribute("data-predictive-search-url") || "/search/suggest";

      if (predictiveSearchUrl.slice(-5) !== ".json") {
        predictiveSearchUrl += ".json";
      }

      if (!input || !form || !panel || !topTemplate) {
        return;
      }
      var debounceTimer;
      var placeholderTimer;
      var requestController;
      var activeRequest = 0;
      var placeholderWordIndex = 0;
      var placeholderCharacterIndex = 0;
      var placeholderDeleting = false;
      var fallbackPlaceholders = [
        "top-selling products",
        "storage organizers",
        "smart home essentials",
        "kitchen accessories"
      ];

      var topProductTitles = Array.from(
        topTemplate.content.querySelectorAll("[data-product-title]")
      )
        .map(function (item) {
          return item.getAttribute("data-product-title");
        })
        .filter(Boolean);

      var placeholderWords = topProductTitles.slice(0, 5);

      if (!placeholderWords.length) {
        placeholderWords = fallbackPlaceholders;
      }

      function setLoading(isLoading) {
        root.classList.toggle("is-loading", isLoading);
      }

      function positionPanel() {
        var formRect = form.getBoundingClientRect();
        var viewportPadding = window.innerWidth <= 640 ? 10 : 16;
        var panelWidth = Math.min(
          formRect.width,
          window.innerWidth - viewportPadding * 2
        );
        var panelLeft = Math.min(
          Math.max(viewportPadding, formRect.left),
          Math.max(viewportPadding, window.innerWidth - panelWidth - viewportPadding)
        );

        panel.style.position = "fixed";
        panel.style.top = Math.round(formRect.bottom + 10) + "px";
        panel.style.right = "auto";
        panel.style.left = Math.round(panelLeft) + "px";
        panel.style.width = Math.round(panelWidth) + "px";
        panel.style.maxHeight =
          Math.max(190, window.innerHeight - formRect.bottom - 24) + "px";
      }

      function setOpen(isOpen) {
        if (isOpen) {
          positionPanel();

          if (
            typeof panel.showPopover === "function" &&
            !panel.matches(":popover-open")
          ) {
            try {
              panel.showPopover();
            } catch (error) {
              panel.removeAttribute("popover");
            }
          } else if (typeof panel.showPopover !== "function") {
            panel.removeAttribute("popover");
          }
        } else if (
          typeof panel.hidePopover === "function" &&
          panel.matches(":popover-open")
        ) {
          try {
            panel.hidePopover();
          } catch (error) {
            /* The panel is already closed. */
          }
        }

        panel.classList.toggle("is-open", isOpen);
        input.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }

      function closePanel() {
        setOpen(false);
      }

      function showTopProducts() {
        panel.replaceChildren(topTemplate.content.cloneNode(true));
        setOpen(true);
      }

      function createElement(tagName, className, textContent) {
        var element = document.createElement(tagName);
        element.className = className;

        if (typeof textContent === "string") {
          element.textContent = textContent;
        }

        return element;
      }

      function createEmptyState(title, message) {
        panel.replaceChildren();

        var state = createElement("div", "dv-empty-state");
        var icon = createElement("span", "dv-empty-icon", "⌕");
        var heading = createElement("strong", "", title);
        var copy = createElement("span", "", message);

        icon.setAttribute("aria-hidden", "true");
        state.append(icon, heading, copy);
        panel.appendChild(state);
        setOpen(true);
      }

      function renderSkeleton() {
        panel.replaceChildren();

        for (var index = 0; index < 4; index += 1) {
          var skeleton = createElement("div", "dv-search-skeleton");
          var image = createElement("span", "dv-skeleton-block");
          var copy = createElement("span", "dv-skeleton-copy");
          var lineOne = createElement("span", "dv-skeleton-line");
          var lineTwo = createElement("span", "dv-skeleton-line");
          var price = createElement("span", "dv-skeleton-line dv-skeleton-price");

          copy.append(lineOne, lineTwo);
          skeleton.append(image, copy, price);
          panel.appendChild(skeleton);
        }

        setOpen(true);
      }

      function createProductItem(product, index) {
        var item = createElement("a", "dv-result-item dv-result-focus");
        var imageUrl = product.image || "";
        var title = product.title || "Product";
        var productUrl = product.url || "#";
        var productPrice = product.price || "";

        item.href = productUrl;
        item.setAttribute("role", "option");
        item.style.setProperty("--dv-order", index);

        if (imageUrl) {
          var image = document.createElement("img");
          image.className = "dv-result-image";
          image.src = imageUrl;
          image.alt = title;
          image.loading = "lazy";
          image.width = 66;
          image.height = 66;
          item.appendChild(image);
        } else {
          var fallback = createElement("span", "dv-image-fallback", "D");
          fallback.setAttribute("aria-hidden", "true");
          item.appendChild(fallback);
        }

        var copy = createElement("span", "dv-result-copy");
        var heading = createElement("span", "dv-result-title", title);
        var type = createElement(
          "span",
          "dv-result-type",
          product.type ? product.type : "View product"
        );

        copy.append(heading, type);
        item.appendChild(copy);

        if (productPrice) {
          item.appendChild(createElement("span", "dv-result-price", productPrice));
        }

        return item;
      }

      function createSearchUrl(query) {
        return (
          "/search?q=" +
          encodeURIComponent(query) +
          "&type=product&options%5Bprefix%5D=last"
        );
      }

      function renderProducts(products, originalQuery, correctedQuery) {
        panel.replaceChildren();

        if (!products.length) {
          createEmptyState(
            "No matching products found",
            "Try a shorter product name or press Enter for the full search."
          );
          return;
        }

        var heading = createElement("div", "dv-results-heading");
        heading.append(
          createElement("strong", "", correctedQuery ? "Suggested products" : "Products"),
          createElement(
            "span",
            "dv-result-count",
            products.length + (products.length === 1 ? " result" : " results")
          )
        );
        panel.appendChild(heading);

        if (correctedQuery) {
          var correction = createElement("div", "dv-correction");
          var correctionPrefix = createElement("span", "", "Showing results for");
          var correctionTerm = createElement("strong", "", "“" + correctedQuery + "”");
          correction.append(correctionPrefix, correctionTerm);
          panel.appendChild(correction);
        }

        var list = createElement("div", "dv-result-list");

        products.forEach(function (product, index) {
          list.appendChild(createProductItem(product, index));
        });

        panel.appendChild(list);

        var footer = createElement("div", "dv-panel-footer");
        var viewAll = createElement(
          "a",
          "dv-view-all dv-result-focus",
          "View all results →"
        );
        viewAll.href = createSearchUrl(correctedQuery || originalQuery);
        footer.appendChild(viewAll);
        panel.appendChild(footer);
        setOpen(true);
      }

      function normalizeQuery(value) {
        return value
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      }

      function levenshtein(left, right) {
        var row = [];
        var previousRow = [];
        var leftIndex;
        var rightIndex;

        for (rightIndex = 0; rightIndex <= right.length; rightIndex += 1) {
          previousRow[rightIndex] = rightIndex;
        }

        for (leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
          row = [leftIndex];

          for (rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
            var insertion = row[rightIndex - 1] + 1;
            var deletion = previousRow[rightIndex] + 1;
            var substitution =
              previousRow[rightIndex - 1] +
              (left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1);
            row[rightIndex] = Math.min(insertion, deletion, substitution);
          }

          previousRow = row;
        }

        return previousRow[right.length];
      }

      function findLocalCorrection(query) {
        var dictionary = [];

        topProductTitles.forEach(function (title) {
          normalizeQuery(title)
            .split(" ")
            .forEach(function (word) {
              if (word.length > 2 && dictionary.indexOf(word) === -1) {
                dictionary.push(word);
              }
            });
        });

        if (!dictionary.length) {
          return "";
        }

        var changed = false;
        var correctedWords = normalizeQuery(query)
          .split(" ")
          .map(function (word) {
            if (word.length < 3 || dictionary.indexOf(word) > -1) {
              return word;
            }

            var bestWord = word;
            var bestDistance = Infinity;

            dictionary.forEach(function (candidate) {
              var distance = levenshtein(word, candidate);

              if (distance < bestDistance) {
                bestDistance = distance;
                bestWord = candidate;
              }
            });

            var allowedDistance = word.length >= 7 ? 2 : 1;

            if (bestDistance <= allowedDistance) {
              changed = true;
              return bestWord;
            }

            return word;
          });

        return changed ? correctedWords.join(" ") : "";
      }

      function getShopifyCorrection(queries, originalQuery) {
        if (!Array.isArray(queries) || !queries.length) {
          return "";
        }

        var suggestion = queries[0] || {};
        var text = suggestion.text || "";

        if (!text && suggestion.styled_text) {
          var parser = document.createElement("div");
          parser.innerHTML = suggestion.styled_text;
          text = parser.textContent || "";
        }

        text = text.trim();

        if (!text || normalizeQuery(text) === normalizeQuery(originalQuery)) {
          return "";
        }

        return text;
      }

      function buildEndpoint(query) {
        return (
          predictiveSearchUrl +
          "?q=" +
          encodeURIComponent(query) +
          "&resources[type]=product,query" +
          "&resources[limit]=8" +
          "&resources[options][fields]=title,product_type,variants.title,variants.sku" +
          "&resources[options][unavailable_products]=last"
        );
      }

      function requestProducts(query, originalQuery, correctionAttempted, requestId) {
        return fetch(buildEndpoint(query), {
          signal: requestController.signal,
          headers: {
            Accept: "application/json"
          }
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Predictive search request failed");
            }

            return response.json();
          })
          .then(function (data) {
            if (
              requestId !== activeRequest ||
              normalizeQuery(input.value) !== normalizeQuery(originalQuery)
            ) {
              return;
            }

            var results =
              data && data.resources && data.resources.results
                ? data.resources.results
                : {};
            var products = Array.isArray(results.products) ? results.products : [];
            var queries = Array.isArray(results.queries) ? results.queries : [];

            if (!products.length && !correctionAttempted) {
              var correctedQuery =
                getShopifyCorrection(queries, originalQuery) ||
                findLocalCorrection(originalQuery);

              if (correctedQuery) {
                return requestProducts(
                  correctedQuery,
                  originalQuery,
                  true,
                  requestId
                );
              }
            }

            renderProducts(
              products,
              originalQuery,
              correctionAttempted && normalizeQuery(query) !== normalizeQuery(originalQuery)
                ? query
                : ""
            );
          });
      }

      function searchProducts(query) {
        if (requestController) {
          requestController.abort();
        }

        requestController = new AbortController();
        activeRequest += 1;
        var requestId = activeRequest;

        setLoading(true);
        renderSkeleton();

        requestProducts(query, query, false, requestId)
          .catch(function (error) {
            if (error.name === "AbortError") {
              return;
            }

            createEmptyState(
              "Search is temporarily unavailable",
              "Press Enter to continue to the full search page."
            );
          })
          .finally(function () {
            if (requestId === activeRequest) {
              setLoading(false);
            }
          });
      }

      function animatePlaceholder() {
        if (!document.body.contains(root)) {
          return;
        }

        if (input.value.length > 0) {
          placeholderTimer = window.setTimeout(animatePlaceholder, 650);
          return;
        }

        var word = placeholderWords[placeholderWordIndex];

        if (!placeholderDeleting) {
          placeholderCharacterIndex += 1;
          input.placeholder =
            "Search " + word.substring(0, placeholderCharacterIndex);

          if (placeholderCharacterIndex >= word.length) {
            placeholderDeleting = true;
            placeholderTimer = window.setTimeout(animatePlaceholder, 1400);
            return;
          }
        } else {
          placeholderCharacterIndex -= 1;
          input.placeholder =
            "Search " + word.substring(0, placeholderCharacterIndex);

          if (placeholderCharacterIndex <= 0) {
            placeholderDeleting = false;
            placeholderWordIndex =
              (placeholderWordIndex + 1) % placeholderWords.length;
          }
        }

        placeholderTimer = window.setTimeout(
          animatePlaceholder,
          placeholderDeleting ? 38 : 68
        );
      }

      input.addEventListener("focus", function () {
        if (input.value.trim().length < 2) {
          showTopProducts();
        }
      });

      input.addEventListener("click", function () {
        if (input.value.trim().length < 2 && !panel.classList.contains("is-open")) {
          showTopProducts();
        }
      });

      input.addEventListener("input", function () {
        var query = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (requestController) {
          requestController.abort();
        }

        setLoading(false);

        if (query.length < 2) {
          showTopProducts();
          return;
        }

        debounceTimer = window.setTimeout(function () {
          searchProducts(query);
        }, 220);
      });

      input.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closePanel();
          return;
        }

        if (event.key === "ArrowDown" && panel.classList.contains("is-open")) {
          var firstResult = panel.querySelector(".dv-result-focus");

          if (firstResult) {
            event.preventDefault();
            firstResult.focus();
          }
        }
      });

      panel.addEventListener("keydown", function (event) {
        var results = Array.from(panel.querySelectorAll(".dv-result-focus"));
        var currentIndex = results.indexOf(document.activeElement);

        if (event.key === "Escape") {
          closePanel();
          input.focus();
          return;
        }

        if (!results.length || currentIndex < 0) {
          return;
        }

        if (event.key === "ArrowDown") {
          event.preventDefault();
          results[(currentIndex + 1) % results.length].focus();
        }

        if (event.key === "ArrowUp") {
          event.preventDefault();

          if (currentIndex === 0) {
            input.focus();
          } else {
            results[currentIndex - 1].focus();
          }
        }
      });

      document.addEventListener("click", function (event) {
        if (!root.contains(event.target)) {
          closePanel();
        }
      });

      form.addEventListener("submit", function () {
        setLoading(true);
      });

      window.addEventListener("resize", function () {
        if (panel.classList.contains("is-open")) {
          positionPanel();
        }
      });

      window.addEventListener(
        "scroll",
        function () {
          if (panel.classList.contains("is-open")) {
            positionPanel();
          }
        },
        true
      );

      document.addEventListener("shopify:section:unload", function (event) {
        if (event.target.contains(root)) {
          window.clearTimeout(debounceTimer);
          window.clearTimeout(placeholderTimer);

          if (requestController) {
            requestController.abort();
          }
        }
      });

      animatePlaceholder();
    }

    function initializeAll(scope) {
      var roots = [];

      if (scope.matches && scope.matches("[data-search-root]")) {
        roots.push(scope);
      }

      if (scope.querySelectorAll) {
        roots = roots.concat(
          Array.from(scope.querySelectorAll("[data-search-root]"))
        );
      }

      roots.forEach(function (root) {
        initializeSearch(root);
      });
    }

    function initializePage() {
      initializeAll(document);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializePage, { once: true });
    } else {
      initializePage();
    }

    document.addEventListener("shopify:section:load", function (event) {
      initializeAll(event.target);
    });

    var searchObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.from(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType === 1) {
            initializeAll(node);
          }
        });
      });
    });

    function observeLateSections() {
      if (document.body) {
        searchObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", observeLateSections, {
        once: true
      });
    } else {
      observeLateSections();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["darvaza-magic-search-guide-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openMagicSearch(trigger) {
      var searchInput = document.querySelector(
        "[data-search-root] .dv-search-input, #dbLiveSearchInput"
      );

      if (!searchInput) {
        window.location.assign("/search");
        return;
      }

      searchInput.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
        block: "center"
      });

      window.setTimeout(function () {
        searchInput.focus({ preventScroll: true });
        searchInput.click();
      }, 520);

      trigger.setAttribute("aria-pressed", "true");

      window.setTimeout(function () {
        trigger.removeAttribute("aria-pressed");
      }, 900);
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-dv-search-trigger]");

      if (trigger) {
        openMagicSearch(trigger);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discount-watch-buy-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeWatchAndBuy(root) {
      if (!root || root.dataset.dowbReady === "true") {
        return;
      }

      root.dataset.dowbReady = "true";

      var rail = root.querySelector("[data-dowb-rail]");
      var videos = Array.from(
        root.querySelectorAll("video.dowb-video, .dowb-video-frame > video")
      );
      var prefetchedLinks = new Set();

      function prefetchProduct(link) {
        var href = link ? link.href : "";

        if (!href || prefetchedLinks.has(href)) {
          return;
        }

        prefetchedLinks.add(href);

        var preload = document.createElement("link");
        preload.rel = "prefetch";
        preload.href = href;
        preload.as = "document";
        document.head.appendChild(preload);
      }

      function updateSoundButton(video, soundIsOn) {
        var frame = video ? video.closest(".dowb-video-frame") : null;
        var button = frame ? frame.querySelector("[data-dowb-sound]") : null;

        if (!button) {
          return;
        }

        button.classList.toggle("is-on", soundIsOn);
        button.setAttribute(
          "aria-label",
          soundIsOn ? "Mute this video" : "Unmute this video"
        );
        button.setAttribute("aria-pressed", soundIsOn ? "true" : "false");
      }

      function setVideoSound(video, soundIsOn) {
        if (!video) {
          return;
        }

        if (soundIsOn) {
          video.removeAttribute("muted");
          video.defaultMuted = false;
          video.muted = false;
          video.volume = 1;

          var playPromise = video.play();

          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function () {
              video.muted = true;
              video.defaultMuted = true;
              video.setAttribute("muted", "");
              updateSoundButton(video, false);
            });
          }
        } else {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute("muted", "");
        }

        updateSoundButton(video, soundIsOn);
      }

      function muteAllExcept(activeVideo) {
        document
          .querySelectorAll("[data-dowb-section] video")
          .forEach(function (video) {
            if (video !== activeVideo) {
              video.muted = true;
              video.defaultMuted = true;
              video.setAttribute("muted", "");

              var otherFrame = video.closest(".dowb-video-frame");
              var otherButton = otherFrame
                ? otherFrame.querySelector("[data-dowb-sound]")
                : null;

              if (otherButton) {
                otherButton.classList.remove("is-on");
                otherButton.setAttribute("aria-label", "Unmute this video");
                otherButton.setAttribute("aria-pressed", "false");
              }
            }
          });
      }

      function toggleVideoSound(video) {
        if (!video) {
          return;
        }

        var shouldTurnSoundOn = video.muted || video.hasAttribute("muted");

        if (shouldTurnSoundOn) {
          muteAllExcept(video);
        }

        setVideoSound(video, shouldTurnSoundOn);
      }

      root.querySelectorAll("[data-dowb-fast-link]").forEach(function (link) {
        link.addEventListener(
          "touchstart",
          function () {
            prefetchProduct(link);
          },
          { passive: true }
        );
        link.addEventListener(
          "mouseenter",
          function () {
            prefetchProduct(link);
          },
          { passive: true }
        );
        link.addEventListener(
          "focus",
          function () {
            prefetchProduct(link);
          },
          { passive: true }
        );
      });

      root.querySelectorAll("[data-dowb-sound]").forEach(function (button) {
        button.setAttribute("aria-pressed", "false");
        button.setAttribute("aria-label", "Unmute this video");

        button.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var frame = button.closest(".dowb-video-frame");
          var video = frame ? frame.querySelector("video") : null;
          toggleVideoSound(video);
        });
      });

      root.querySelectorAll(".dowb-video-frame").forEach(function (frame) {
        var video = frame.querySelector("video");

        if (!video) {
          return;
        }

        frame.setAttribute("tabindex", "0");
        frame.setAttribute("role", "button");
        frame.setAttribute("aria-label", "Click to turn video sound on or off");

        frame.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" && event.key !== " ") {
            return;
          }

          event.preventDefault();
          toggleVideoSound(video);
        });
      });

      videos.forEach(function (video) {
        setVideoSound(video, false);
      });

      var previousButton = root.querySelector("[data-dowb-prev]");
      var nextButton = root.querySelector("[data-dowb-next]");

      if (previousButton) {
        previousButton.addEventListener("click", function () {
          if (!rail) {
            return;
          }

          rail.scrollBy({
            left: -Math.round(rail.clientWidth * 0.8),
            behavior: "smooth"
          });
        });
      }

      if (nextButton) {
        nextButton.addEventListener("click", function () {
          if (!rail) {
            return;
          }

          rail.scrollBy({
            left: Math.round(rail.clientWidth * 0.8),
            behavior: "smooth"
          });
        });
      }

      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;

              if (entry.isIntersecting) {
                var playPromise = video.play();

                if (playPromise && typeof playPromise.catch === "function") {
                  playPromise.catch(function () {});
                }
              } else {
                video.pause();
                setVideoSound(video, false);
              }
            });
          },
          { threshold: 0.36 }
        );

        videos.forEach(function (video) {
          observer.observe(video);
        });

        root.dowbObserver = observer;
      }

      function muteWhenHidden() {
        if (!document.hidden) {
          return;
        }

        videos.forEach(function (video) {
          setVideoSound(video, false);
        });
      }

      document.addEventListener("visibilitychange", muteWhenHidden);
      root.dowbMuteWhenHidden = muteWhenHidden;
    }

    function initializeAllWatchAndBuy(scope) {
      var roots = [];

      if (scope.matches && scope.matches("[data-dowb-section]")) {
        roots.push(scope);
      }

      if (scope.querySelectorAll) {
        roots = roots.concat(
          Array.from(scope.querySelectorAll("[data-dowb-section]"))
        );
      }

      roots.forEach(function (root) {
        initializeWatchAndBuy(root);
      });
    }

    function initializePage() {
      initializeAllWatchAndBuy(document);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initializePage, {
        once: true
      });
    } else {
      initializePage();
    }

    document.addEventListener("shopify:section:load", function (event) {
      initializeAllWatchAndBuy(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      var root = event.target.querySelector
        ? event.target.querySelector("[data-dowb-section]")
        : null;

      if (!root) {
        return;
      }

      if (root.dowbObserver) {
        root.dowbObserver.disconnect();
      }

      if (root.dowbMuteWhenHidden) {
        document.removeEventListener(
          "visibilitychange",
          root.dowbMuteWhenHidden
        );
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
